/*global Modernizr, ajaxurl, console */
/*jslint browser:true */

const mobility_express_rate_directions = {
  '03TO': { // MoPac Express
    'nb': [
      {
        value: 'cvz',
        name: 'Cesar Chavez'
      },
      {
        value: 'farwest',
        name: 'Far West'
      }
    ],
    'sb': [
      {
        value: 'parmer',
        name: 'Parmer'
      },
      {
        value: '2222',
        name: '2222'
      }
    ]
  },
  '07TO': { // 183N
    'nb': [
      {
        value: 'burnet',
        name: 'Burnet'
      },
      {
        value: 'duval-nb',
        name: 'Duval'
      }
    ],
    'sb': [
      {
        value: 'avery-ranch',
        name: 'Avery Ranch'
      },
      {
        value: 'duval-sb',
        name: 'Duval'
      }
    ]
  }
};

const mobility_express_tpn_map = {
  '03TO': { // MoPac Express
    'cvz': {
      'tollPoints': [
        'LP1X NB: CVZ to 183',
        'LP1X NB: CVZ to Parmer'
      ],
      'signClass': 'nb-mopac-cvz'
    },
    'farwest': {
      'tollPoints': [
        {
          'facility': '07TO',
          'tollPoint': '183N-MPACDCNB-TO-MPACDCNB'
        },
        'LP1X NB: 2222 to Parmer'
      ],
      'signClass': 'nb-mopac-farwest'
    },
    'parmer': {
      'tollPoints': [
        'LP1X SB: Parmer to 2222',
        'LP1X SB: Parmer to 5th/CVZ'
      ],
      'signClass': 'sb-mopac-parmer'
    },
    '2222': {
      'tollPoints': [
        'LP1X SB: 2222 to 5th/CVZ'
      ],
      'signClass': 'sb-mopac-2222'
    }
  },
  '07TO': { // 183N
    'burnet': {
      'tollPoints': [
        '183N-STNLKBLVDNB-TO-STNLKBLVDNB',
        '183N-STNLKBLVDNB-TO-MCNLMLNB',
        {
          'tollPoint': '183N-STNLKBLVDNB-TO-MCNLMLNB',
          'include': {
            'facility': '01TO',
            'tollPoint': '183A-LKLNMLNB-TO-LKLNMLNB'
          }
        }
      ],
      'signClass': 'nb-183n-burnet'
    },
    'duval-nb': {
      'tollPoints': [
        '183N-MCNLMLNB-TO-MCNLMLNB',
        {
          'tollPoint': '183N-MCNLMLNB-TO-MCNLMLNB',
          'include': {
            'facility': '01TO',
            'tollPoint': '183A-LKLNMLNB-TO-LKLNMLNB'
          }
        }
      ],
      'signClass': 'nb-183n-duval'
    },
    'avery-ranch': {
      'tollPoints': [
        '183N-MCNLMLSB-TO-MCNLMLSB'
      ],
      'signClass': 'sb-183n-avery-ranch'
    },
    'duval-sb': {
      'tollPoints': [
        '183N-MPACDCSB-TO-MPACDCSB',
        '183N-STNLKBLVDSB-TO-STNLKBLVDSB'
      ],
      'signClass': 'sb-183n-duval'
    }
  }
};

function mobility_express_fetch_rates(facilities, rate_filter_date, run_success, run_error) {
  "use strict";

  var request = new XMLHttpRequest();

  request.addEventListener('readystatechange', function() {
    if(this.readyState === 4) {
      if (this.status === 200) {
        var data = JSON.parse(this.response);

        if(data) {
          run_success(data);
        } else {
          console.log('JSON Error', this.response);
          run_error();
        }
      } else {
        console.log('Error', this.statusText);
        run_error();
      }
    }
  });

  request.open('POST', ajaxurl, true);

  var data = new FormData();
  data.append('action', 'express_rates');
  data.append('starttime', rate_filter_date);
  data.append('facilities', facilities.join(','));

  request.send(data);
}

function mobility_express_toll_point_data(datum) {
  "use strict";

  var clean = {};
  clean.tpn = datum.tollingPointName;
  clean.status = datum.status || 'O';

  if(clean.status !== 'CLOSED') {
    clean.tripRate = datum.tripRate || 0.00;
    clean.pbmRate = datum.pbmRate || 0.00;
    clean.rate = mobility_express_rate_format_money(datum.tripRate);
    clean.pbm = mobility_express_rate_format_money(datum.pbmRate);
  } else {
    clean.tripRate = datum.tripRate || 0.00;
    clean.pbmRate = datum.pbmRate || 0.00;
    clean.rate = 'CLOSED';
    clean.pbm = 'CLOSED';
  }

  return clean;
}

function mobility_express_sum_rates(point1, point2) {
  "use strict";

  if(point1.status === 'CLOSED' || point2.status === 'CLOSED') {
    point1.rate = 'CLOSED';
    point2.pbm = 'CLOSED';
  } else {
    point1.rate = mobility_express_rate_format_money(((point1.tripRate * 100) + (point2.tripRate * 100)) / 100);
    point1.pbm = mobility_express_rate_format_money(((point1.pbmRate * 100) + (point2.pbmRate * 100)) / 100);
  }

  return point1;
}

function mobility_express_rate_format_money(rate) {
  "use strict";

  return '$ ' + rate.toFixed(2);
}